import { useQuery } from "@tanstack/react-query";
import { sanityClient, homePageQuery, type HomePage, type Settings } from "../sanity";

export interface HomePageData {
  homePage: HomePage | null;
  settings: Settings | null;
}

export function useHomePage() {
  return useQuery({
    queryKey: ["homePage"],
    queryFn: () => sanityClient.fetch<HomePageData>(homePageQuery),
    staleTime: 1000 * 60 * 5,
  });
}
